import React, { useEffect } from 'react'
import useShop from '../context/AppContext'
import styled, { ThemeProvider } from 'styled-components'
import { useLocation } from 'react-router-dom'
import { GlobalStyle, theme } from '../styles'
import { Header, Footer } from '../container'
import { Preloader } from '../components'

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const StyledMain = styled.main`
  width: 100%;
  padding-top: 100px;
`

const Layout = ({ children }) => {
  const { preloaderExecuted } = useShop()
  const { pathname } = useLocation()

  useEffect(() => {
    console.log(pathname)
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' //instant/smooth
    })
  }, [pathname])

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {preloaderExecuted ? (
        <StyledContent>
          <Header />
          <div id="content">
            <StyledMain>{children}</StyledMain>
            <Footer />
          </div>
        </StyledContent>
      ) : (
        <Preloader />
      )}
    </ThemeProvider>
  )
}

export default Layout
